import type { AxiosResponse } from 'axios';

type ErrorWithResponse = { response?: AxiosResponse | Record<string, unknown> };

export function handleInterceptError<TError extends ErrorWithResponse>(error: TError): Promise<unknown> {
  // to ensure code that expects legacy errors works as expected we "unwrap" the actual error details that axios
  // returns nested under the "response" property.
  return Promise.reject({ ...error, ...(error.response ?? {}) });
}
